
export const GET_FIRM_CARDS_QUERY = `
  query GetFirmCards($offset: Int, $limit: Int, $where: firm_carts_bool_exp, $order_by: [firm_carts_order_by!]) {
    firm_carts(offset: $offset, limit: $limit, where: $where, order_by: $order_by) {
      id
      firm_id
      firm_cart_firstname
      firm_cart_lastname
      firm_cart_mail
      firm_cart_phone
      firm_cart_second_phone
      firm_cart_status
      firm_cart_title
      firm_cart_task
      firm_cart_description
      created_at
    }
    firm_carts_aggregate(where: $where) {
      aggregate {
        count
      }
    }
  }
`;

export const GET_FIRM_CARD_BY_ID_QUERY = `
  query GetFirmCardById($id: Int!) {
    firm_carts_by_pk(id: $id) {
      id
      firm_id
      firm_cart_firstname
      firm_cart_lastname
      firm_cart_mail
      firm_cart_phone
      firm_cart_second_phone
      firm_cart_status
      firm_cart_title
      firm_cart_task
      firm_cart_description
      created_at
    }
  }
`; 